// extracted by mini-css-extract-plugin
export default {"containerButtonPrice":"LoginButton_containerButtonPrice__kTj-I","buttonWrapper":"LoginButton_buttonWrapper__bhPuR","innerButton":"LoginButton_innerButton__mog4H"};